import UltMeta, { Meta } from "./UltMeta/index";

class Search extends UltMeta {
    SEARCH_TERM = new Meta(1, "搜索词");
    PRODUCT = new Meta(2, "商品");
    PRODUCT_TYPE_INDEX = new Meta(3, "砂价");
    SHIPPING_PRICE = new Meta(4, "运价");
    ADVERTISING_PAGE = new Meta(5, "广告页");
    INFORMATION = new Meta(6, "资讯");
}

export const SEARCH = new Search();
